
import { PropType } from "vue";
import { Options, prop, Vue } from "vue-class-component";
import RegularScheduleSection from "./RegularScheduleSection.vue";
import { RegularDaySchedule } from "./schedule-types";
import SpecialScheduleSection from "../components/SpecialDateSchedule.vue";

interface TimeSlot {
  start: string;
  end: string;
}

interface SpecialDateSchedule {
  date: string;
  slots: TimeSlot[];
}

class Props {
  enabled = prop<boolean>({ default: false, type: Boolean });
  days = prop<RegularDaySchedule[]>({
    default: () => [],
    type: Array as PropType<RegularDaySchedule[]>
  });
  specialEnabled = prop<boolean>({ default: false, type: Boolean });
  specialDates = prop<SpecialDateSchedule[]>({
    default: () => [],
    type: Array as PropType<SpecialDateSchedule[]>
  });
  loading = prop<boolean>({ default: false, type: Boolean });
  slotStartHour = prop<number>({ default: 8, type: Number });
  slotEndHour = prop<number>({ default: 23, type: Number });
  slotIntervalMinutes = prop<number>({ default: 60, type: Number });
}

@Options({
  components: {
    RegularScheduleSection,
    SpecialScheduleSection
  },
  emits: [
    "update:enabled",
    "update:days",
    "update:specialEnabled",
    "update:specialDates"
  ]
})
export default class SchedulePickupSection extends Vue.with(Props) {
  get enabledValue(): boolean {
    return this.enabled;
  }

  set enabledValue(value: boolean) {
    this.$emit("update:enabled", value);
  }

  get dayValues(): RegularDaySchedule[] {
    return this.days;
  }

  set dayValues(value: RegularDaySchedule[]) {
    this.$emit("update:days", value);
  }

  get specialEnabledValue(): boolean {
    return this.specialEnabled;
  }
  set specialEnabledValue(value: boolean) {
    this.$emit("update:specialEnabled", value);
  }

  get specialDateValues(): SpecialDateSchedule[] {
    return this.specialDates;
  }
  set specialDateValues(value: SpecialDateSchedule[]) {
    this.$emit("update:specialDates", value);
  }
}
